import React, { memo, useState } from 'react';
import ReactDOM from 'react-dom';
import Scrollbars from 'react-custom-scrollbars';
import styled from 'styled-components';

import Cookies from '../modules/Cookies';
import { resolveLang } from 'common/handleLocale';

/** @typedef {{[index: number]: boolean}} selectedGroupIndex */

/** @type {React.Dispatch<React.SetStateAction<SPOT_READ[]>> | undefined} */
let setSpotsTrigger;
/** @type {React.Dispatch<React.SetStateAction<selectedGroupIndex>>} | undefined} */
let setSelectedGroupIndexTrigger;
/** @type {React.Dispatch<React.SetStateAction<boolean>>} | undefined} */
let setCheckedInTrigger;

$(document).on('click', '#showSpotFilterModal', () => {
  if (setSpotsTrigger) {
    setSpotsTrigger(window.mapSpotsCurrent.ori);
  }
  if (setSelectedGroupIndexTrigger) {
    /** @type {selectedGroupIndex} */
    const savedGroupIndex = {};
    if (window.SpotFilterSelectedSettings) {
      window.SpotFilterSelectedSettings.filterGroups.forEach((index) => {
        savedGroupIndex[index] = true;
      });
    }
    setSelectedGroupIndexTrigger(savedGroupIndex);
  }
  if (setCheckedInTrigger) {
    setCheckedInTrigger(
      !!window.SpotFilterSelectedSettings &&
        window.SpotFilterSelectedSettings.showOnlyCheckedIn
    );
  }
});

const SpotFilterModalComponent = () => {


  const [spots, setSpots] = useState(window.mapSpotsCurrent.ori);
  setSpotsTrigger = setSpots;

  let uniqueArr = [... new Set(spots.map(data => data.new_icon))];
  uniqueArr = uniqueArr.filter(function( element ) {
      return element !== undefined;
  });
  let allFilterGroups = uniqueArr.map((str) => ({ icons: str }));
  window.Gdata.SpotFilter = allFilterGroups;
  /** @type {[selectedGroupIndex, React.Dispatch<React.SetStateAction<selectedGroupIndex>>]} */
  const [selectedGroupIndex, setSelectedGroupIndex] = useState({});
  setSelectedGroupIndexTrigger = setSelectedGroupIndex;

  const [checkedIn, setCheckedIn] = useState(false);
  setCheckedInTrigger = setCheckedIn;

  const filterGroups = allFilterGroups
    .map((group, index) => ({ ...group, count: 0, index }))
    .filter((group) => {
      group.count = spots.reduce(
        (acc, { message_board_enabled, new_icon = '', team_dialy_count = 0 }) => {
          if (!message_board_enabled && group.icons == new_icon) {
            if ((checkedIn == 'checked' && team_dialy_count > 0) || (checkedIn == 'unCheck' && team_dialy_count == 0) || (checkedIn == 'all' || checkedIn == false)) {
              acc++;
            }
          }
          return acc;
        },
        0
      );

      return group.count;
    });
  return (
    <div className="modalInner">
      <div className="modalHead">
        <p>{resolveLang('絞り込み')}</p>
        <i className="closeModal" />
      </div>
      <div className="modalBody flex flex-col">
        <div className="flex-1">
          <Scrollbars autoHide style={{ background: '#f5f5f5', height: '92%' }}>
            {filterGroups.map(
              ({ icons, count, index }) => (
                <label
                  key={index}
                  className={`flex items-center cursor-pointer py-2 bg-white m-2 rounded border-2 border-solid border-white ${
                    !!selectedGroupIndex[index] && 'bg-blue-100 border-blue-500'
                  }`}
                  htmlFor={`helloTest${index}`}
                >
                  <input
                    id={`helloTest${index}`}
                    type="checkbox"
                    checked={!!selectedGroupIndex[index]}
                    onChange={(e) => {
                      if (e.currentTarget.checked) {
                        selectedGroupIndex[index] = true;
                      } else {
                        delete selectedGroupIndex[index];
                      }
                      setSelectedGroupIndex({
                        ...selectedGroupIndex,
                      });
                    }}
                  />
                  <CheckBoxDiv
                    className="bg-black mx-4 bg-contain"
                    style={{
                      background: `url(/img/tmp/${
                        selectedGroupIndex[index]
                          ? 'checkbox_on.png'
                          : 'checkbox_off.png'
                      })`,
                    }}
                  />
                  <div className="block flex-1 flex items-center">
                    <div className="openSpot iconL">
                      <div className={`newIconColor SICblue`} />
                      <div className={`newIcon SI${icons}`} />
                    </div>
                    <span
                      className="bold text-base pl-2"
                      style={{ marginTop: -4 }}
                    >
                      ({count})
                    </span>
                  </div>
                </label>
              )
            )}
          </Scrollbars>
        </div>
        <div className="multiswitch" >
          <div className="slide-container">
            <input type="radio" name="stoplight" id="stoplight1" value="all" onChange={(e) => {setCheckedIn(e.currentTarget.value);}} defaultChecked />
            <label htmlFor="stoplight1">すべて</label>
            <input type="radio" name="stoplight" id="stoplight2" value="checked" onChange={(e) => {setCheckedIn(e.currentTarget.value);}} />
            <label htmlFor="stoplight2">チェックイン済</label>
            <input type="radio" name="stoplight" id="stoplight3" value="unCheck" onChange={(e) => {setCheckedIn(e.currentTarget.value);}} />
            <label htmlFor="stoplight3">未チェックイン</label>
            <a className="slide" aria-hidden="true"></a>
          </div>
        </div>
        <div className="p-2 flex bg-white">
          <button
            className="btnWhite btnBig px-4 mr-2"
            onClick={() => {
              setSelectedGroupIndex({});
              setCheckedIn(false);
            }}
          >
            {resolveLang('選択解除')}
          </button>
          <button
            className="closeModal btnBlue btnBig flex-1"
            onClick={() => {
              window.SpotFilterSelectedSettings = {
                showOnlyCheckedIn: checkedIn,
                filterGroups: Object.keys(selectedGroupIndex).map((index) =>
                  parseInt(index, 10)
                ),
              };

              window.MainMap.removeSpots();
              window.MainMap.populateSpots(window.mapSpotsCurrent.ori);
            }}
          >
            {resolveLang('実行')}
          </button>
        </div>
      </div>
    </div>
  );
};

$(() => {
  if (Cookies.get('session')) {
    ReactDOM.render(
      <SpotFilterModalComponent />,
      document.getElementById('SpotFilterModal')
    );
  }
});

//#region styles
const CheckBoxDiv = styled.div`
  width: 20px;
  height: 20px;
`;
//#endregion
